import Applications from "#/modules/applications/Applications";

export default Applications;
